<ng-container *ngIf="(isMobile$ | async) === false; else mobileSort">
  <div data-test-sorting-desktop class="mr-small-t ms-small-b">
    <fcom-tabs
      #tabs
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      [theme]="TabTheme.CLASSIC"
      [layoutType]="TabLayoutType.STRETCH"
      (clickedTab)="onSortChangeFromTabs($event)"
    >
      <fcom-tab
        *ngIf="showBestFlightsTab"
        [title]="
          (resultsAmount === 1 ? 'flightSorting.bestFlights.singular' : 'flightSorting.bestFlights.plural')
            | finLocalization
        "
        [data]="SortBy.BEST"
        [subtitle]="
          shouldShowTabSubtitle
            ? ('flightSorting.flightsFrom'
              | finLocalization: { amount: { amount: bestFlightPrice, currencyCode } | finPrice })
            : '-'
        "
        [contentTooltip]="contentTooltip"
        [active]="(selectedSortBy$ | async) === SortBy.BEST"
      >
      </fcom-tab>
      <fcom-tab
        *ngIf="true"
        [title]="'flightSorting.lowestPrice' | finLocalization"
        [data]="SortBy.PRICE"
        [subtitle]="
          shouldShowTabSubtitle
            ? ('flightSorting.flightsFrom'
              | finLocalization
                : {
                    amount: showPoints
                      ? ('award.points' | finLocalization: { pointsAmount: lowestPrice | finPoints })
                      : ({ amount: lowestPrice, currencyCode } | finPrice)
                  })
            : '-'
        "
        [active]="(selectedSortBy$ | async) === SortBy.PRICE"
      >
      </fcom-tab>
      <fcom-tab
        *ngIf="true"
        [title]="'flightSorting.fastest' | finLocalization"
        [data]="SortBy.DURATION"
        [subtitle]="
          shouldShowTabSubtitle
            ? ('flightSorting.flightsFrom'
              | finLocalization
                : {
                    amount: showPoints
                      ? ('award.points' | finLocalization: { pointsAmount: fastestFlightPrice | finPoints })
                      : ({ amount: fastestFlightPrice, currencyCode } | finPrice)
                  })
            : '-'
        "
        [active]="(selectedSortBy$ | async) === SortBy.DURATION"
      >
      </fcom-tab>
    </fcom-tabs>

    <ng-template #contentTooltip>
      <h2 class="align-left font-body-1 bold-type nordic-blue-900-text">
        {{ 'flightSorting.tooltip.title' | finLocalization }}
      </h2>
      <p class="pr-xxsmall-t regular-type align-left">{{ 'flightSorting.tooltip.text' | finLocalization }}</p>
    </ng-template>
  </div>
</ng-container>

<ng-template #mobileSort>
  <button
    data-test-sorting-mobile
    class="sort-mobile-button ms-small-y flex flex--no-wrap flex--center rounded-medium font-body-1 white-bg border nordic-blue-400-border"
    (click)="openSortingModal()"
  >
    <fcom-icon name="sort-descending" class="icon-small ms-xxsmall-l flex flex--self-center"></fcom-icon>
    <span class="ps-small-y ps-xxsmall-l">
      <ng-container [ngSwitch]="selectedSortBy$ | async">
        <span *ngIf="showBestFlightsTab">
          <span *ngSwitchCase="SortBy.BEST">{{
            (resultsAmount === 1 ? 'flightSorting.bestFlights.singular' : 'flightSorting.bestFlights.plural')
              | finLocalization
          }}</span>
        </span>
        <span *ngSwitchCase="SortBy.PRICE">{{ 'flightSorting.lowestPrice' | finLocalization }}</span>
        <span *ngSwitchCase="SortBy.DURATION">{{ 'flightSorting.fastest' | finLocalization }}</span>
      </ng-container>
    </span>
  </button>

  <fcom-modal
    [(open)]="modalOpen"
    [title]="'flightSorting.sortingCriteria' | finLocalization"
    (close)="closeSortingModal()"
    data-test-sorting-mobile-modal
  >
    <div class="ps-medium flex flex--column flex--left-center">
      <ng-container *ngIf="showBestFlightsTab">
        <fin-input-radio
          [name]="'flightSorting.bestFlights.plural' | finLocalization"
          (radioChange)="onSortChangeFromModal(SortBy.BEST)"
          [value]="SortBy.BEST"
          [selected]="(selectedSortBy$ | async) === SortBy.BEST"
          [label]="'flightSorting.bestFlights.plural' | finLocalization"
        />
        <p class="grey-600-text font-body-2 regular-type ps-xxsmall-t ps-xlarge-l">
          {{ 'flightSorting.tooltip.text' | finLocalization }}
        </p>
      </ng-container>

      <fin-input-radio
        [name]="'flightSorting.lowestPrice' | finLocalization"
        (radioChange)="onSortChangeFromModal(SortBy.PRICE)"
        [value]="SortBy.PRICE"
        [selected]="(selectedSortBy$ | async) === SortBy.PRICE"
        [label]="'flightSorting.lowestPrice' | finLocalization"
      />
      <fin-input-radio
        [name]="'flightSorting.fastest' | finLocalization"
        (radioChange)="onSortChangeFromModal(SortBy.DURATION)"
        [value]="SortBy.DURATION"
        [selected]="(selectedSortBy$ | async) === SortBy.DURATION"
        [label]="'flightSorting.fastest' | finLocalization"
      />
    </div>
  </fcom-modal>
</ng-template>
